const locale = {
	TAB_INVOICES_DEADLINES: 'Scadenze',
	TAB_INVOICES_DEADLINES_CALENDAR: 'Calendario Scadenze',

	VIEW_ITEM_BUTTON_NEW_INVOICE: 'Aggiungi Fattura',

	DIALOG_TITLE_INVOICES_MODULE_ADD_TITLE: 'Aggiungi Fattura',
	DIALOG_TITLE_INVOICES_MODULE_EDIT_TITLE: 'Modifica Fattura collegata',

	// #region Invoices fields
	DETAILS_INVOICES_FIELD_TITLE: 'Numero',
	DETAILS_INVOICES_FIELD_STATUS: 'Stato Fattura',
	DETAILS_INVOICES_FIELD_TYPE: 'Tipo Fattura',
	DETAILS_INVOICES_FIELD_COMPANY: 'Azienda',
	DETAILS_INVOICES_FIELD_ASSIGNED_USER: 'Utente assegnato',
	DETAILS_INVOICES_FIELD_DATE_ISSUE: 'Data emissione',
	// DETAILS_INVOICES_FIELD_DATE_EXPIRATION: 'Data scadenza',
	// DETAILS_INVOICES_FIELD_DATE_PAYMENT: 'Data pagamento',
	DETAILS_INVOICES_FIELD_AMOUNT_RESIDUAL: 'Importo residuo (tasse escluse)',
	DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_EXCL: 'Importo fatturato (tasse escluse)',
	DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_INCL: 'Importo fatturato (tasse incluse)',
	DETAILS_INVOICES_FIELD_PAYMENTTERMS: 'Termini di pagamento',
	DETAILS_INVOICES_FIELD_PAYMENTMETHOD: 'Metodo di pagamento',
	DETAILS_INVOICES_FIELD_INTERNALNUMBER: 'N. Protocollo',

	DETAILS_INVOICES_FIELD_HAS_AMOUNT_RESIDUAL: 'Fattura parziale',

	DETAILS_INVOICES_OPTION_NEW_INVOICE: 'Crea nuova Fattura',
	DETAILS_INVOICES_OPTION_LINK_INVOICE: 'Collega Fattura esistente',
	// #endregion

	// #region Invoices Rows section
	INVOICES_ROWS_SECTION_TITLE: 'Righe Fattura',

	INVOICES_ROWS_COLUMN_DESCRIPTION: 'Note',
	INVOICES_ROWS_COLUMN_TABLE: 'Tipo Documento collegato',
	INVOICES_ROWS_COLUMN_TABLE_TITLE: 'Documento collegato',
	INVOICES_ROWS_COLUMN_TABLE_LINE_TITLE: 'Riga Documento collegato',
	INVOICES_ROWS_COLUMN_AMOUNT: 'Importo (tasse escluse)',

	INVOICES_ROWS_SECTION_TOT_ROWS_AMOUNT: 'Importo totale (tasse escluse): {value}',
	INVOICES_ROWS_SECTION_TOT_INVOICE_AMOUNT_RESIDUAL: 'Importo residuo (tasse escluse): {value}',
	// #endregion

	// #region Invoices Deadlines section
	INVOICES_DEADLINES_SECTION_TITLE: 'Scadenze Fattura',

	INVOICES_DEADLINES_COLUMN_INVOICE_TITLE: 'Numero Fattura',
	INVOICES_DEADLINES_COLUMN_COMPANY: 'Azienda',
	INVOICES_DEADLINES_COLUMN_DATE_DEADLINE: 'Data scadenza',
	INVOICES_DEADLINES_COLUMN_DATE_PAYMENT: 'Data pagamento',
	INVOICES_DEADLINES_COLUMN_AMOUNT: 'Importo previsto',
	INVOICES_DEADLINES_COLUMN_AMOUNT_PAYMENT: 'Importo saldato',
	INVOICES_DEADLINES_COLUMN_PAYMENT_TYPE: 'Metodo pagamento',
	INVOICES_DEADLINES_COLUMN_SUBTYPE: 'Sottotipo',
	INVOICES_DEADLINES_COLUMN_FORCE_CLOSE: 'Chiusura forzata',
	INVOICES_DEADLINES_COLUMN_CLOSED: 'Chiusa',
	INVOICES_DEADLINES_COLUMN_NOTES: 'Note',

	INVOICES_DEADLINES_SECTION_TOT_AMOUNT_DEADLINE_RESIDUAL: 'Importo residuo: {value}'
	// #endregion
};

export default locale;
